import { render, staticRenderFns } from "./InvestorWalletInfoTab.vue?vue&type=template&id=7bbe47b8"
import script from "./InvestorWalletInfoTab.vue?vue&type=script&lang=js"
export * from "./InvestorWalletInfoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports